import { GooglePayButtonTypes, googlePayButtonTypesArr } from './types';

export const DEFAULT_GOOGLE_PAY_BUTTON_TYPE = 'plain';

export const googlePayBtnLimits = {
  borderRadius: {
    defaultValue: 4,
    min: 0,
    max: 100,
  },
  height: {
    defaultValue: 40,
    min: 40,
    max: 100,
  },
  width: {
    defaultValue: 240,
    min: 160,
    max: 800,
  },
};

export const isValidGooglePayButtonType = (
  googlePayButtonTypeArg: string | null | undefined,
): googlePayButtonTypeArg is GooglePayButtonTypes => {
  if (!googlePayButtonTypeArg) {
    return false;
  }

  return googlePayButtonTypesArr.includes(googlePayButtonTypeArg as GooglePayButtonTypes);
};

export const clamp = (
  value: string | null,
  limits: {
    min: number,
    max: number,
    defaultValue: number,
  },
): number => {
  return (!value || isNaN(Number(value)))
    ? limits.defaultValue
    : Math.min(Math.max(Number(value), limits.min), limits.max);
};
